// Function definitions
const _mapJob = function (job){
    if(job.billing_address){
        for(let index in job.billing_address){
            if(job.billing_address.hasOwnProperty(index) && index !== 'id'){
                job[index] = job.billing_address[index];
            }
        }
    }
    if (job.time_slots) {
        for (let t of job.time_slots) {
            t.start = window.moment(t.start);
            t.end = window.moment(t.end);
        }
    }
    if (job.first_time_slot) {
        job.first_time_slot.start = window.moment(job.first_time_slot.start);
        job.first_time_slot.end = window.moment(job.first_time_slot.end);
    }

    delete(job.billing_address);

    if (job.created_at) {
        job.created_at = window.moment(job.created_at);
    }

    if (job.updated_at) {
        job.updated_at = window.moment(job.updated_at);
    }

    if (job.invoiced_at) {
        job.invoiced_at = window.moment(job.invoiced_at);
    }

    return job;
};

const search = function(params = {}){
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/jobs', {
            params: params,
        }).then(xhr => {
            let jobs = [];
            for (let index in xhr.data.data){
                jobs.push(_mapJob(xhr.data.data[index]));
            }
            xhr.data.data = jobs;
            fulfill(xhr);
        }, error => {
            reject(error);
        })
    });
};

const get = function(id, params = {}){
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/jobs/'+id, {
            params: params,
        }).then(xhr => {
            xhr.data = _mapJob(xhr.data);
            fulfill(xhr);
        }, error => {
            reject(error);
        });
    });
};

const inventory = function(id) {
    return window.axios.get(`/api/jobs/${id}/inventory`);
};

const create = function(job){
    return window.axios.post('/api/jobs', job);
};

const update = function(job){
    return window.axios.put('/api/jobs/'+job.id, job);
};

const attended = function(job){
    return window.axios.post('/api/jobs/'+job.id+'/attended');
};

const deleteJob = function(job){
    return window.axios.delete('/api/jobs/'+job.id, job);
};

const reportMissingHandover = function (params) {
    return window.axios.get('/api/jobs/report/missing-handover', {params});
};

const handoverChecked = function(job, value) {
    return window.axios.put(`/api/jobs/${job.id}/handover-checked`, {checked: value});
};

export default {
    search,
    get,
    inventory,
    create,
    update,
    attended,
    delete: deleteJob,
    _mapJob,
    reportMissingHandover,
    handoverChecked,
}


// WEBPACK FOOTER //
// ./resources/assets/js/services/JobService.js